export const SAML_LOGIN_URL = "/saml/login";
export const SAML_TOKEN_PAGE = "/login/saml";
export const HOME_PAGE = "/";
